<!-- Portal — Sign in (Quiet Authority). Full-viewport split: form column on the
     left, dark report panel on the right (Paper artboard 1440×900). All three
     portals share this shell; the admin/staff variant swaps the eyebrow/copy and
     the right panel's content (specimen report is member-only). With
     `embeddedLoginEnabled` off the form renders its redirect variant — one CTA
     to Auth0 Universal Login, no decorative fields. -->
<div class="abx-signin">
  <div class="abx-signin__column">
    <a routerLink="" class="abx-signin__brand" aria-label="AppliedBioX home">
      <bodyanalytics-brand-logo [variant]="theme.isDark() ? 'dark' : 'light'" [height]="28" />
    </a>

    <div class="abx-signin__form-block">
      <header class="abx-signin__heading">
        <p class="abx-signin__eyebrow">{{ isAdminPortal() ? 'Staff portal' : 'Customer portal' }}</p>
        <h1 class="abx-signin__title">Welcome back.</h1>
        <p class="abx-signin__subtitle">
          @if (isAdminPortal()) {
            Sign in to manage testing events, bookings, and customer records.
          } @else {
            Sign in to see your results, your history and your next session.
          }
        </p>
      </header>

      <bodyanalytics-embedded-login-form
        [embeddedEnabled]="embeddedEnabled"
        [pending]="signInPending()"
        [errorMessage]="signInError()"
        [showCreateAccount]="!isAdminPortal()"
        (credentialsSubmit)="onCredentialsSubmit($event)"
        (redirectLogin)="onRedirectLogin()"
        (forgotPassword)="onForgotPassword($event)"
        (createAccount)="signup()" />
    </div>

    <nav class="abx-signin__legal" aria-label="Legal">
      <a class="abx-signin__legal-link" [href]="privacyUrl" target="_blank" rel="noopener">Privacy</a>
      <a class="abx-signin__legal-link" [href]="termsUrl" target="_blank" rel="noopener">Terms</a>
      <a class="abx-signin__legal-link" [href]="helpUrl" target="_blank" rel="noopener">Help</a>
      <span class="abx-signin__legal-copy">© {{ currentYear }} AppliedBioX</span>
    </nav>
  </div>

  <aside class="abx-signin__panel" aria-hidden="true">
    <div class="abx-signin__panel-photo"></div>
    <div class="abx-signin__panel-wash"></div>

    @if (isAdminPortal()) {
      <p class="abx-signin__panel-eyebrow">Operations</p>
      <div class="abx-signin__panel-body">
        <h2 class="abx-signin__panel-greeting">Good {{ staffGreeting }}, team.</h2>
      </div>
      <p class="abx-signin__panel-foot">Every session you run today becomes<br />someone else's proof of progress.</p>
    } @else {
      <p class="abx-signin__panel-eyebrow">Your latest report</p>
      <div class="abx-signin__panel-body">
        <div class="abx-signin__report-head">
          <div class="abx-signin__report-metric">
            <p class="abx-signin__report-label">Body fat</p>
            <p class="abx-signin__report-numeral">18.4%</p>
          </div>
          <div class="abx-signin__report-delta">
            <p class="abx-signin__report-delta-value">−1.2 pts</p>
            <p class="abx-signin__report-label">since 05.2026</p>
          </div>
        </div>
        <dl class="abx-signin__report-rows">
          <div class="abx-signin__report-row">
            <dt>Lean mass</dt>
            <dd>126.4 lb</dd>
          </div>
          <div class="abx-signin__report-row">
            <dt>Fat mass</dt>
            <dd>28.6 lb</dd>
          </div>
          <div class="abx-signin__report-row">
            <dt>Body density</dt>
            <dd>1.0647 g/cc</dd>
          </div>
          <div class="abx-signin__report-row">
            <dt>Next session</dt>
            <dd>Sep 12 · The Colony</dd>
          </div>
        </dl>
      </div>
      <p class="abx-signin__panel-foot">Every session, on record.<br />One number you can build on.</p>
    }
  </aside>
</div>
